import { render, staticRenderFns } from "./AiWidgetView.vue?vue&type=template&id=472b3f97&scoped=true&"
import script from "./AiWidgetView.vue?vue&type=script&lang=js&"
export * from "./AiWidgetView.vue?vue&type=script&lang=js&"
import style0 from "./AiWidgetView.vue?vue&type=style&index=0&id=472b3f97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472b3f97",
  null
  
)

export default component.exports